import { createSelector } from 'reselect';

export const getPartnerCurrency = state =>
  state.global.currencies[state.global.partner.currency];

const filterCryptoCurrencies = currencies =>
  Object.entries(currencies).reduce((acc, cur) => {
    if (cur[1].currency_type === 'crypto' && cur[1].iso4217 !== 'NCCO') {
      acc.push(cur[1]);
    }
    return acc;
  }, []);

export const getCurrencies = state => state.global.currencies;

export const getCurrencyFromParams = (state, props) =>
  state.global.currencies[props.match.params.id];

export const getReferralCryptoWallet = state =>
  state.account.cryptoWallets.referralCryptoWallets;

export const cryptoWallet = (currency, wallets) => {
  if (wallets && currency.currency_type !== 'fiat') {
    const normalizedCurrency = currency.iso4217.toLowerCase();
    return wallets[`${normalizedCurrency}_wallet_address`];
  }
};

const filterFiatCurrencies = currencies =>
  Object.entries(currencies).reduce((acc, cur) => {
    if (cur[1].currency_type === 'fiat' && cur[1].enabled) {
      acc.push(cur[1]);
    }
    return acc;
  }, []);

export const currencyName = currency => {
  switch (currency.iso4217.toLowerCase()) {
    case 'usd':
      return 'USD';
    case 'cad':
      return 'CAD';
    default:
      return currency.name;
  }
};

export const currencyColor = currency => currency.color;
export const currencyType = currency => currency.currency_type;

export const getFiatCurrencies = createSelector(
  getCurrencies,
  filterFiatCurrencies
);

export const getCryptoCurrencies = createSelector(
  getCurrencies,
  filterCryptoCurrencies
);

export const makeGetCurrencyName = () =>
  createSelector(getCurrencyFromParams, currencyName);

export const makeGetCurrencyColor = () =>
  createSelector(getCurrencyFromParams, currencyColor);

export const makeGetCurrencyType = () =>
  createSelector(getCurrencyFromParams, currencyType);

export const makeGetCryptoWallet = () =>
  createSelector(getCurrencyFromParams, getReferralCryptoWallet, cryptoWallet);
